import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { NgForOf, NgIf } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { TripAttraction, TripPlan } from '../../../../shared/models/vititor.trip.storage.command';
import { TripPlannerService } from '../../../services/trip.planner.service';

@Component({
  selector: 'ig-create-edit-plan',
  standalone: true,
  imports: [
    MatFormField,
    MatIcon,
    MatLabel,
    MatMenu,
    MatOption,
    MatSelect,
    NgForOf,
    SharedModule,
    FormsModule,
    NgIf
  ],
  templateUrl: './create.edit.plan.component.html',
  styleUrl: './create.edit.plan.component.scss'
})
export class CreateEditPlanComponent implements OnInit {
  planForm: FormGroup;
  selectedType = null;

  @Input() type: 'prePlans' | 'postPlans' = 'prePlans';
  @Input() attraction: TripAttraction = null;
  @Input() plan: TripPlan = null;  // for editing a plan
  planTypes = TripPlannerService.planTypes;

  @Output() onUpdated = new EventEmitter<TripPlan>();

  constructor(private _fb: FormBuilder) {
    this.planForm = this._fb.group({
      time: [null, []],
      content: [null, []],
      type: [null, []],
      title: [null, []],
    });
  }

  createPlan(attraction: TripAttraction, trigger: MatMenuTrigger) {
    const time = this.planForm.get('time').value;
    const title = this.planForm.get('title').value;
    const content = this.planForm.get('content').value;

    console.log('time', time);
    console.log('content', content);
    console.log('type', this.selectedType);

    if (this.plan) {
      this.plan = {
        type: this.selectedType,
        time,
        title,
        content
      };

      this.onUpdated.emit(this.plan);
      trigger && trigger.closeMenu();
      return;
    }

    if (!attraction[this.type]) attraction[this.type] = [];

    attraction[this.type].push({
      type: this.selectedType,
      time,
      title,
      content
    });

    trigger && trigger.closeMenu();
  }

  planTypeChange(event: MatSelectChange) {
    // if (event.value && !this.planForm.get('title').value) {
    this.planForm.get('title').setValue(event.value);
    // }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.stopPropagation();
    }
  }

  ngOnInit(): void {
    if (this.plan) {
      this.selectedType = this.plan.type;
      this.planForm.get('time').setValue(this.plan.time);
      this.planForm.get('title').setValue(this.plan.title);
      this.planForm.get('content').setValue(this.plan.content);
    }
  }
}
